export default "__VITE_ASSET__DSyAXLYk__"